<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
 
  <div class="row">
    <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px"></div>
    <div class="routes-1 opensans-semi-bold-sapphire-30px">
      <span class="opensans-semi-bold-sapphire-30px">{{lblHeading}}</span>
      <div class="rectangle-210"></div>
    </div>
    
  </div>
  
  <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form [formGroup]="form">
        <div class="col-md-12" style="margin:0px;padding:0px;">
          <div class="row">
        <div class="col-md-3" style="margin: 0px; padding: 0px;">
        <table style="margin:0px;padding:0px;width:100%">
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;width:50%;vertical-align:top;">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-12 no-sp">
                  <div class="col-md-12 row">
                  <div class="col-sm-6 control-label ">Code<a class="red-asterik">*</a></div>
                  <div class="col-sm-6 control-label "><span class="pull-right"><a style="cursor: default; text-decoration:underline;" (click)="clearForm()">Clear Form</a></span></div> 
                </div>
                  <div class="col-md-12">
                    <input type="text" name="code" formControlName="code" class="form-control" />
                    <div class="form-control-feedback text-danger text-small"
                      *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                      <p *ngIf="form.controls.code.errors.required">Code is required</p>
                      <p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12 characters.</p>
                    </div>
                  </div>
                </div>
                
              </div>
            </td>
          </tr>
          <tr>
            <div class="col-md-12 no-sp">
              <div class="col-sm-12 control-label ">Name<a class="red-asterik">*</a></div>
           <div class="col-md-12">
              <input type="text" name="name" (keydown.enter)="$event.preventDefault()" formControlName="name" class="form-control" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search/>
            </div>
          </div>
          </tr>
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px; padding:0px;width:50%; vertical-align:top;">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-12 no-sp">
                  <div class="col-sm-12 control-label " style="margin-bottom: 5px;">Country<a class="red-asterik">*</a></div>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="country_id" id="country" #country>
                      <option value="" >Select Country</option>
                      <ng-container *ngFor="let list of countryList">
                        <option [value]="list.id">{{list.desc}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
                
                
              </div>
            </td>
          </tr>
          <tr>
            <div class="col-md-12 no-sp">
              <div class="col-sm-12 control-label " style="margin-bottom: 5px;">Province</div>
              <div class="col-md-12">
                <select class="form-control" formControlName="province_id" id="province" #province>
                  <option value="">Select Province</option>
                  <ng-container *ngFor="let list of provinceList; let k=index;">
                    <ng-container *ngIf="country.value==list.country_id">
                      <option [value]="list.id">{{list.description}}</option>
                    </ng-container>
                  </ng-container>
                </select>
              </div>
            </div>
          </tr>
          <tr>
            <div class="col-md-12 no-sp">                 
              <div class="col-sm-12 control-label " style="margin-top: 5px;margin-bottom: 5px;">In Town</div>
              <div class="col-md-12">
                <select class="form-control" *ngIf="!IsNewPlace" formControlName="parent_place_id" id="intown"
                  title="You can locate a place in another place. For example, you can say that terminus is in a town.">
                  <option value="">Select Town</option>
                  <ng-container *ngFor="let list of placeList; let k=index;">
                    <ng-container *ngIf="province.value==list.province_id">
                      <option [value]="list.id">{{list.name}}</option>
                    </ng-container>
                  </ng-container>
                </select>               
                <input type="text" *ngIf="IsNewPlace" name="placeName" formControlName="place_name" class="form-control" disabled="true"
                  title="Name of the town" />
              </div>
            </div>  
          </tr>

          <tr style="margin:0px;padding:0px;" class="">
            <td style="margin:0px;padding:0px;" colspan="2">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-12 no-sp">
                  <div class="col-sm-12 control-label ">Longitude</div>
                  <div class="col-md-12">
                    <input type="text" formControlName="longitude" name="longitude" class="form-control"
                      title="Decimal degrees longitude (eg. 29.986285)" />
                  </div>
                </div>
                
                
              </div>
            </td>
          </tr>
          <tr>
            <div class="col-md-12 no-sp">
              <div class="col-sm-12 control-label ">Latitude</div>
              <div class="col-md-12">
                <input type="text" name="latitude" formControlName="latitude" class="form-control"
                  title="Decimal degrees latitude (eg. -22.225100)" />
              </div>
            </div>
          </tr>
          <tr style="display: none;">
            <div class="col-md-12 no-sp">
              <div class="col-sm-12 control-label ">Coordinates</div>
              <div class="col-md-12">
                <input type="text" name="coordinates" formControlName="coordinates" class="form-control"
                  title="DMS co-ordinates (eg. 22º13’30.36’S,29º59’10.63”E)" />
              </div>
            </div>
          </tr>
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="col-md-12">
                <div class="row col-md-12">
                <div class="form-check form-check-inline col-md-6  no-sp" style="margin-top:10px;padding-top:10px;">
                  <div class="control-label " style="width:150px;"> Town?</div>
                  <input class="form-control form-control-sm ckbox" formControlName="is_town" type="checkbox" id="town"
                    title="Is the place a town?" />
                </div>
                <div class="form-check form-check-inline col-md-6  no-sp" style="margin-top:10px;padding-top:10px;padding-left:30px">
                  <div class="control-label " style="width:150px;">Taxi Rank?</div>
                  <input class="form-control input-sm ckbox" formControlName="is_taxi_rank" type="checkbox" id="taxi-rank"
                    title="Is the place a taxi rank?" />
                </div>
                </div>

                <div class="row col-md-12">
                  <div class="form-check form-check-inline col-md-12 no-sp" style="margin-top:10px;padding-top:10px;">
                    <div class="control-label " style="width:150px;">Terminus?</div>
                    <input class="form-control input-sm ckbox" formControlName="is_terminus" type="checkbox" id="terminus"
                      title="Is the place a terminus where a passenger route can start or terminate?" />
                  </div>

                </div>

                <div  class="row col-md-12">
                  <div class="form-check form-check-inline col-md-12 no-sp" style="margin-top:0px;padding-top:0px;">
                    <table style="width: 100%;">
                      <tr>
                        <td>
                          <div class="form-check form-check-inline col-md-12" style="margin-top:10px;padding-top:10px;">
                            <div class="control-label " style="width:150px;"> Border Crossing?</div>
                            <input #isBorderCrossingRef class="form-control input-sm ckbox" formControlName="is_border_post"
                              type="checkbox" id="border" title="Is the place a border crossing?" (click)="borderPostChange(isBorderCrossingRef)" />
                          </div>
                        </td>
                        
                      </tr>
                      <tr>
                        <td style="padding-top: 20px;">
                          
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

                <div *ngIf="isBorderCrossingRef.checked" class="row" style="padding:0px;">
                  <div class="col-md-6 no-sp">
                          <div class="col-sm-12 control-label ">From country(south or east):</div>
                          <div class="col-md-12">
                          <select class="form-control" formControlName="border_country1_id">
                            <option value="0">Select Country</option>
                            <ng-container *ngFor="let list of countryList">
                              <option [value]="list.id">{{list.desc}}</option>
                            </ng-container>
                          </select>
                        </div>
                  </div>
                  <div class="col-md-6 no-sp" style="padding-right: 0px;">
                          <div class="col-sm-12 control-label ">To country(north or west):</div>
                          <div class="col-md-12">
                          <select class="form-control" formControlName="border_country2_id" style="margin-right: 10px;">
                            <option value="0">Select Country</option>
                            <ng-container *ngFor="let list of countryList">
                              <option [value]="list.id">{{list.desc}}</option>
                            </ng-container>
                          </select>
                        </div>
                  </div>
                  
                </div>

              </div>
            </td>
          </tr>
          <tr style="margin-top:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="col-md-12 no-sp" style="margin-top:5px;">
                <div class="col-sm-12 control-label " style="width:150px;">Type</div>
                <div class="col-sm-12 control-label "></div>
                <div class="col-md-12">
                  <input type="text" formControlName="type" name="ttype" class="form-control"
                    title="Free text field to add a type if none of the above or to supplement the above categories.?" />
                </div>
              </div>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="row" style="margin:5px auto;padding:0px; display:none">
                <div class="col-md-6 no-sp">
                  <div class="col-sm-12 control-label " style="padding-bottom:5px">Sort Order</div>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="sort_order" id="sortorder">
                      <option value="">Select Sort Order</option>
                      <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 no-sp">
                  <div class="col-sm-12 control-label ">Group Code</div>
                  <div class="col-md-12">
                    <input type="text" formControlName="group_code" name="groupCode" class="form-control" />
                  </div>
                </div>
                
              </div>
            </td>
          </tr>
         <tr>
          <div class="row" style="margin:5px auto;padding:0px;">
          <div class="col-md-6 no-sp" style="display:none">
            <div class="col-sm-12 control-label " style="padding-bottom:5px">Display When</div>
            <div class="col-md-12">
              <select class="form-control" formControlName="display_ind" id="intown">
                <option value="">Select Display</option>
                <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6 no-sp">
            <div class="col-sm-12 control-label ">Active</div>
            <div class="form-check form-check-inline col-md-12" style="padding-left: 15px;padding-top:5px">
              <input class="form-control input-sm ckbox" formControlName="is_active" type="checkbox" id="active" />
            </div>
          </div>
        </div>
         </tr>
        </table>
        </div>
        <div class="col-md-9" style="margin:0px;padding:0px;padding-right: 45px;">
          <agm-map [latitude]="lat" [longitude]="lng" draggableCursor="default" draggingCursor="default" (mapClick)="onChoosePlace($event)" #myMap>
            <agm-marker *ngIf="locationChosen" [latitude]="lat" [longitude]="lng" [markerDraggable]="false"  (dragEnd)="markerDragEnd($event)"></agm-marker>
          </agm-map>
        </div>
      </div>
        </div>
        <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;">
          <dl style="width:460px;display:inline-block;">
            <dt style="width:40px;">Created</dt>
            <dd [innerHTML]="audit.created"></dd>
            <dt style="width:46px;">Updated</dt>
            <dd [innerHTML]="audit.updated"></dd>
          </dl>
        </div>

        <!-- End -->

        <hr>
        <div class="col-md-12">
          <br>
          <button title="Save change(s)" type="submit" id="btnSave" (click)="savePlace()"
            class="btn hd-btn pull-right" style="width:10%; margin-left:10px; ">Save</button>
          <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/countries/list/'+placeId]"
            class="btn hd-btn-close pull-right" *ngIf="!this.fromRouteAdmin" style="width:10%; margin-left:10px; ">Back</button>
        </div>
      </form>
    </div>
    
  </div>
</div>
<!--End Container -->
